import DashboardItemDetails from "./DashboardItemDetails";

export default DashboardItemDetails;